export default __webpack_public_path__ + "what.60db3e7c3d92932ebbf0b529b36fde78.svg";